module.exports = __webpack_public_path__ + "img/sleeve_length.8b302406.png";